import { createSlice, configureStore } from '@reduxjs/toolkit';

const initialState = {
    style: "Bend",
    size: "18x18",
    productSelection: [],
    activeProfile: null,
    roomscene: "Mannington\\Images\\Amtico\\Hospitality_Overhead",
    currentView: "swatch", // 'swatch' or 'room'
    currentImageUrl: null
};

const appSlice = createSlice({
    name: "app",
    initialState,
    reducers: {
        setStyle(state, action) {
            state.style = action.payload;
        },
        setSize(state, action) {
            state.size = action.payload;
        },
        setProductSelection(state, action) {
            state.productSelection = action.payload;
        },
        addProduct(state, action) {
            state.productSelection.push(action.payload);
        },
        removeProduct(state, action) {
            state.productSelection = state.productSelection.filter(id => id !== action.payload);
        },
        clearProductSelection(state) {
            state.productSelection = [];
        },
        setActiveProfile(state, action) {
            state.activeProfile = action.payload;
        },
        clearActiveProfile(state) {
            state.activeProfile = null;
        },
        setRoomscene(state, action) {
            state.roomscene = action.payload;
        },
        setCurrentView(state, action) {
            state.currentView = action.payload;
        },
        setCurrentImageUrl(state, action) {
            state.currentImageUrl = action.payload;
        }
    }
});

const store = configureStore({
    reducer: {
        app: appSlice.reducer
    }
});

export const appActions = appSlice.actions;
export default store;
